import { DesBaseCollabAcc } from './des-base-collab-acc';
export class DesBaseRfq extends DesBaseCollabAcc {

    constructor(ViewModel) {
        super(ViewModel);
        this.ViewModel = ViewModel;
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid,
            rfqid: this.rfqid
        };
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute('collaborationspace-id');
    }

    get rfqid() {
        return this.getAttribute('rfqid') || this.getAttribute('rfq-id');
    }

    static get observedAttributes() {
        return [ ...DesBaseCollabAcc.observedAttributes, 'collaborationspaceid', 'collaborationspace-id', 'rfqid', 'rfq-id' ];
    }
}
